import { connect } from 'react-redux';
import Alerts from '../../components/alerts';

import {
    fetchAllAlerts,
    setNewTasksVisited,
    badgeCountSuccess
} from '../../actions';

import {
    getAlertsLoading,
    getTasksTouched,
    getPastDueNeedsReviewEvents,
    getPastDueNeedsReviewAfterActions,
    getPastDueReturnedForEditEvents,
    getPastDueReturnedForEditAfterActions,
    getPastDueIncompleteAfterActions,
    getIncompleteEvents,
    getIncompleteAfterActions,
    getIncompleteAssignedAfterActions,
    getNeedsReviewEvents,
    getNeedsReviewAfterActions,
    getPendingApprovalEvents,
    getPendingApprovalAfterActions,
    getReturnedForEditEvents,
    getReturnedForEditAfterActions,
    getRejectedEvents
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: state.data.userInfo,
    alertsLoading: getAlertsLoading(state),
    tasksTouched: getTasksTouched(state),
    pastDueNeedsReview: [
        ...getPastDueNeedsReviewEvents(state),
        ...getPastDueNeedsReviewAfterActions(state)
    ],
    pastDueReturnedForEdit: [
        ...getPastDueReturnedForEditEvents(state),
        ...getPastDueReturnedForEditAfterActions(state)
    ],
    pastDueIncompleteAfterActions: getPastDueIncompleteAfterActions(state),
    incompleteEvents: getIncompleteEvents(state),
    incompleteAfterActions: getIncompleteAfterActions(state),
    incompleteAssignedAfterActions: getIncompleteAssignedAfterActions(state),
    needsReviewEvents: getNeedsReviewEvents(state),
    needsReviewAfterActions: getNeedsReviewAfterActions(state),
    pendingApprovalEvents: getPendingApprovalEvents(state),
    pendingApprovalAfterActions: getPendingApprovalAfterActions(state),
    returnedForEditEvents: getReturnedForEditEvents(state),
    returnedForEditAfterActions: getReturnedForEditAfterActions(state),
    rejectedEvents: getRejectedEvents(state)
});

const mapDispatchToProps = dispatch => ({
    fetchAllAlerts: () => dispatch(fetchAllAlerts()),
    setNewTasksVisited: () => dispatch(setNewTasksVisited()),
    resetBadgeCount: () => dispatch(badgeCountSuccess(0))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Alerts);



// WEBPACK FOOTER //
// ./src/containers/alerts/index.js